export default __webpack_public_path__ + "static/media/central_andes_1_6.cad64014.jpg";